(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-feature-collection"] && !Shopify.designMode) return;
  try {
    
if(typeof Swiper === 'undefined') {
  var swiperScript = document.createElement('script');
  swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
  swiperScript.onload = initSwiper;
  document.head.appendChild(swiperScript);
} else {
  initSwiper();
}

function initSwiper() {
  const totalSlides = window.zisNewTotalSlides || 12;
  // Divide total slides into 3 groups to get 3 dots max
  const slidesPerGroup = Math.ceil(totalSlides / 3);

  new Swiper('.zis-new-feature-collection-slider .zis-new-mySwiper', {
    slidesPerView: 4,
    slidesPerGroup: slidesPerGroup,
    spaceBetween: 16,
    loop: true,
    centeredSlides: false,
    pagination: {
      el: '.zis-new-feature-collection-slider .swiper-pagination',
      clickable: true
    },
    breakpoints: {
      320: { slidesPerView: 1, slidesPerGroup: 1 },
      640: { slidesPerView: 2, slidesPerGroup: 2 },
      1024: { slidesPerView: 4, slidesPerGroup: slidesPerGroup }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.testimonial-slider').slick({
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="56" height="56" rx="28" fill="#3B3B3B" fill-opacity="0.28"/><path d="M12.6695 26.1053C11.7766 26.9981 11.7766 28.4481 12.6695 29.341L24.098 40.7696C24.9909 41.6624 26.4409 41.6624 27.3338 40.7696C28.2266 39.8767 28.2266 38.4267 27.3338 37.5339L19.798 30.0053L41.7123 30.0053C42.9766 30.0053 43.998 28.9839 43.998 27.7196C43.998 26.4553 42.9766 25.4339 41.7123 25.4339L19.8052 25.4339L27.3266 17.9053C28.2195 17.0124 28.2195 15.5624 27.3266 14.6696C26.4338 13.7767 24.9838 13.7767 24.0909 14.6696L12.6623 26.0981L12.6695 26.1053Z" fill="white"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="56" height="56" rx="28" transform="matrix(-1 0 0 1 56 0)" fill="#3B3B3B" fill-opacity="0.28"/><path d="M43.3305 26.1053C44.2234 26.9981 44.2234 28.4481 43.3305 29.341L31.902 40.7696C31.0091 41.6624 29.5591 41.6624 28.6662 40.7696C27.7734 39.8767 27.7734 38.4267 28.6662 37.5339L36.202 30.0053L14.2877 30.0053C13.0234 30.0053 12.002 28.9839 12.002 27.7196C12.002 26.4553 13.0234 25.4339 14.2877 25.4339L36.1948 25.4339L28.6734 17.9053C27.7805 17.0124 27.7805 15.5624 28.6734 14.6696C29.5662 13.7767 31.0162 13.7767 31.9091 14.6696L43.3377 26.0981L43.3305 26.1053Z" fill="white"/></svg></button>'
  });
});

  } catch(e) { console.error(e); }
})();
})();
